<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_iv"></a>Contents</h1>
<h2 class="toc-chap"><a href="#/xhtml/04_Chapter01">The Fugitive</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/05_Chapter02" title="Link target outside of Sample">The Elixir of Death</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/06_Chapter03" title="Link target outside of Sample">Exeunt Omnes</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/07_Chapter04" title="Link target outside of Sample">Four Friends of Mavis</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/08_Chapter05" title="Link target outside of Sample">The Head of Cromwell</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/09_Chapter06" title="Link target outside of Sample">The Widow of Maltrata</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter07" title="Link target outside of Sample">The Princess Antimacassar</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/11_Chapter08" title="Link target outside of Sample">Decadence and John Fenderson</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter09" title="Link target outside of Sample">Coffins for Two</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_Chapter10" title="Link target outside of Sample">The Truth About Delbridge</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter11" title="Link target outside of Sample">The End of the Story</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_Chapter12" title="Link target outside of Sample">The Pleasant Madness of the Faculty</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_Chapter13" title="Link target outside of Sample">Thirty Pieces of Silver</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_Chapter14" title="Link target outside of Sample">The Episode of the Plugged Dime</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/18_Chapter15" title="Link target outside of Sample">The Man Who Loved Leopards</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/19_Chapter16" title="Link target outside of Sample">Request of the Dying</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/20_Chapter17" title="Link target outside of Sample">Eighteen Steps</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/21_Chapter18" title="Link target outside of Sample">The Artistic Temperament</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?e0c95e28